import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import './About.css';

function About() {
    const [isDark, setIsDark] = useState(() => {
        try { return document.documentElement.getAttribute('data-theme') === 'dark'; } catch (e) { return false; }
    });
    const rootRef = useRef(null);

    useEffect(() => {
        // Observe html[data-theme] and mirror to local DOM as a fallback. Apply inline styles to guarantee black backgrounds.
        const applyStyles = (darkNow) => {
            try {
                if (!rootRef.current) return;
                const hero = rootRef.current.querySelector('.hero-section');
                const products = rootRef.current.querySelector('.products-section');
                const mission = rootRef.current.querySelector('.mission-section');
                const cta = rootRef.current.querySelector('.cta-section-about');
                 // toggle class
                 if (darkNow) rootRef.current.classList.add('dark'); else rootRef.current.classList.remove('dark');
                 // apply inline important styles when dark
                 if (darkNow) {
                    [hero, products, mission, cta].forEach(el => {
                        if (!el) return;
                        el.style.setProperty('background', '#16171a', 'important');
                        el.style.setProperty('background-image', 'none', 'important');
                        el.style.setProperty('color', '#e6eef8', 'important');
                    });
                 } else {
                    [hero, products, mission, cta].forEach(el => {
                        if (!el) return;
                        el.style.removeProperty('background');
                        el.style.removeProperty('background-image');
                        el.style.removeProperty('color');
                    });
                 }
             } catch (e) { /* ignore in non-browser */ }
         };

         const observer = new MutationObserver(() => {
             const darkNow = document.documentElement.getAttribute('data-theme') === 'dark';
             setIsDark(darkNow);
             applyStyles(darkNow);
         });
         observer.observe(document.documentElement, { attributes: true, attributeFilter: ['data-theme'] });
         // initial
        applyStyles(document.documentElement.getAttribute('data-theme') === 'dark');
         return () => observer.disconnect();
     }, []);

    return (
        <div ref={rootRef} className={`about-page ${isDark ? 'dark' : ''}`}>
            <section className="hero-section">
                <div className="hero-content">
                    <h1>About Eupraxia Labs</h1>
                    <p>Empowering federal and enterprise organizations with innovative infrastructure solutions.</p>
                </div>
            </section>
            <section className="mission-section">
                <h2>Our Mission</h2>
                <p className="mission-statement">
                    At Eupraxia Labs, we believe federal and enterprise organizations deserve infrastructure that is open, compliant, and cost-effective. Our Federal Frontier portfolio — VitroAI™, FKP™, and Day 2 Apps — helps customers modernize with confidence, without the lock-in of legacy vendors.
                </p>
            </section>
            <section className="products-section">
                <h2>Our Solutions</h2>
                <div className="products-container">
                    <div className="product-card">
                        <h3>VitroAI™</h3>
                        <p>A managed OpenStack hyperconverged infrastructure, FIPS-validated and AI-ready for federal missions.</p>
                        <Link to="/vitro" className="learn-more-button">Learn More</Link>
                    </div>
                    <div className="product-card">
                        <h3>FKP™ (Federal Frontier Kubernetes)</h3>
                        <p>A secure, compliant Kubernetes platform optimized for Day 2 operations in regulated environments.</p>
                        <Link to="/fkp" className="learn-more-button">Learn More</Link>
                    </div>
                    <div className="product-card">
                        <h3>Day 2 Apps</h3>
                        <p>A suite of applications for observability, security, and cost management, integrated into the FKP platform™.</p>
                        <Link to="/day2apps" className="learn-more-button">Learn More</Link>
                    </div>
                </div>
            </section>
            <section className="cta-section-about">
                <h2>Join Us in Modernizing Infrastructure</h2>
                <p>Discover how Eupraxia Labs can support your mission or business needs.</p>
                <Link to="/contact" className="cta-button">Get in Touch</Link>
            </section>
        </div>
    );
}

export default About;